import { trackEvent } from '@host/utils/posthog-track';

// Participants being moved into a breakout show up as meeting_joined with is_breakout; these
// are the moderator's actions.

type BreakoutGroupLike = {
  durationMinutes: number;
  createdAt?: string;
  rooms: { participants?: string[] }[];
};

const countParticipants = (groups: BreakoutGroupLike[]) =>
  groups.reduce(
    (sum, group) =>
      sum + group.rooms.reduce((roomSum, room) => roomSum + (room.participants?.length ?? 0), 0),
    0
  );

export const trackBreakoutConfigured = (props: {
  roomCount: number;
  plannedMinutes: number;
  assignment: string;
  participantCount: number;
}) => {
  trackEvent('breakout_configured', {
    room_count: props.roomCount,
    planned_minutes: props.plannedMinutes,
    assignment: props.assignment,
    participant_count: props.participantCount,
  });
};

export const trackBreakoutStarted = (group: BreakoutGroupLike) => {
  trackEvent('breakout_started', {
    room_count: group.rooms.length,
    participant_count: countParticipants([group]),
    planned_minutes: group.durationMinutes,
  });
};

export const trackBreakoutEnded = (groups: BreakoutGroupLike[], endReason: 'manual' | 'timer') => {
  const createdAt = groups[0]?.createdAt;
  trackEvent('breakout_ended', {
    end_reason: endReason,
    room_count: groups.reduce((sum, group) => sum + group.rooms.length, 0),
    planned_minutes: groups[0]?.durationMinutes ?? null,
    actual_minutes: createdAt
      ? Math.round((Date.now() - new Date(createdAt).getTime()) / 60000)
      : null,
  });
};
